const actions = {
  CREATE_SALES_AGENT_REQUEST: 'salesAgent/CREATE_SALES_AGENT_REQUEST',
  CREATE_SALES_AGENT_SUCCESS: 'salesAgent/CREATE_SALES_AGENT_SUCCESS',
  CREATE_SALES_AGENT_FAILURE: 'salesAgent/CREATE_SALES_AGENT_FAILURE',
  CREATE_SALES_AGENT: 'salesAgent/CREATE_SALES_AGENT',
  GET_SALES_AGENT: 'salesAgent/GET_SALES_AGENT',
  GET_SALES_AGENT_SUCCESS: 'salesAgent/GET_SALES_AGENT_SUCCESS',
  GET_SALES_AGENT_FAILURE: 'salesAgent/GET_SALES_AGENT_FAILURE',
  GET_SALES_AGENT_LOADING: 'salesAgent/GET_SALES_AGENT_LOADING',
  UPDATE_SALES_AGENT_REQUEST: 'salesAgent/UPDATE_SALES_AGENT_REQUEST',
  UPDATE_SALES_AGENT_SUCCESS: 'salesAgent/UPDATE_SALES_AGENT_SUCCESS',
  UPDATE_SALES_AGENT_FAILURE: 'salesAgent/UPDATE_SALES_AGENT_FAILURE',
  UPDATE_SALES_AGENT: 'salesAgent/UPDATE_SALES_AGENT',
  DELETE_SALES_AGENT_REQUEST: 'salesAgent/DELETE_SALES_AGENT_REQUEST',
  DELETE_SALES_AGENT_SUCCESS: 'salesAgent/DELETE_SALES_AGENT_SUCCESS',
  DELETE_SALES_AGENT_FAILURE: 'salesAgent/DELETE_SALES_AGENT_FAILURE',
  DELETE_SALES_AGENT: 'salesAgent/DELETE_SALES_AGENT',
  GET_AGENTS_BY_BUSINESS: 'salesAgent/GET_AGENTS_BY_BUSINESS',
  GET_AGENTS_BY_BUSINESS_LOADING: 'salesAgent/GET_AGENTS_BY_BUSINESS_LOADING',
  GET_AGENTS_BY_BUSINESS_SUCCESS: 'salesAgent/GET_AGENTS_BY_BUSINESS_SUCCESS',
  GET_AGENTS_BY_BUSINESS_FAILURE: 'salesAgent/GET_AGENTS_BY_BUSINESS_FAILURE',
  GET_ALL_SALES_AGENTS: 'salesAgent/GET_ALL_SALES_AGENTS',
  GET_ALL_SALES_AGENTS_LOADING: 'salesAgent/GET_ALL_SALES_AGENTS_LOADING',
  GET_ALL_SALES_AGENTS_SUCCESS: 'salesAgent/GET_ALL_SALES_AGENTS_SUCCESS',
  GET_ALL_SALES_AGENTS_FAILURE: 'salesAgent/GET_ALL_SALES_AGENTS_FAILURE',
  ASSIGN_SALES_AGENT: 'salesAgent/ASSIGN_SALES_AGENT',
  ASSIGN_SALES_AGENT_REQUEST: 'salesAgent/ASSIGN_SALES_AGENT_REQUEST',
  ASSIGN_SALES_AGENT_SUCCESS: 'salesAgent/ASSIGN_SALES_AGENT_SUCCESS',
  ASSIGN_SALES_AGENT_FAILURE: 'salesAgent/ASSIGN_SALES_AGENT_FAILURE',
  REMOVE_MERCHANT_FROM_AGENT_REQUEST: 'salesAgent/REMOVE_MERCHANT_FROM_AGENT_REQUEST',
  REMOVE_MERCHANT_FROM_AGENT_SUCCESS: 'salesAgent/REMOVE_MERCHANT_FROM_AGENT_SUCCESS',
  REMOVE_MERCHANT_FROM_AGENT_FAILURE: 'salesAgent/REMOVE_MERCHANT_FROM_AGENT_FAILURE',
  REMOVE_MERCHANT_FROM_AGENT: 'salesAgent/REMOVE_MERCHANT_FROM_AGENT',
  LOG_AGENT_PAYOUT: 'salesAgent/LOG_AGENT_PAYOUT',
  LOG_AGENT_PAYOUT_SUCCESS: 'salesAgent/LOG_AGENT_PAYOUT_SUCCESS',
  LOG_AGENT_PAYOUT_FAILURE: 'salesAgent/LOG_AGENT_PAYOUT_FAILURE',
  GET_AGENT_PAYOUTS: 'salesAgent/GET_AGENT_PAYOUTS',
  GET_AGENT_PAYOUTS_SUCCESS: 'salesAgent/GET_AGENT_PAYOUTS_SUCCESS',
  GET_AGENT_PAYOUTS_FAILURE: 'salesAgent/GET_AGENT_PAYOUTS_FAILURE',
  ASSUME_AGENT: 'salesAgent/ASSUME_AGENT',
}

export default actions
